import { getWeek, getYear, nextDeliveryWeekDateObj } from "@chef/helpers";
import {
  useProductCategoriesQuery,
  useProductsByCategoriesQuery,
} from "../graphql/generated";
import { getStandaloneProductCategoryIdsFromProductCategories } from "../helpers";

export const useAllVariations = () => {
  const weekObj = nextDeliveryWeekDateObj();
  const week = getWeek(weekObj);
  const year = getYear(weekObj);

  const { data: { productCategories } = {} } = useProductCategoriesQuery();

  const {
    data: { productsByCategories: standaloneProductsByCategories } = {},
  } = useProductsByCategoriesQuery(
    {
      categoryIds: getStandaloneProductCategoryIdsFromProductCategories(
        productCategories || [],
      ),
      week,
      year,
    },
    { skip: !productCategories },
  );

  const allVariations =
    standaloneProductsByCategories?.flatMap(({ products }) =>
      products.flatMap((product) => product.variations),
    ) || [];

  return { allVariations };
};
